<template lang="pug">
//-v-container.style-login(fluid)
    v-row
        v-col
            v-card
                v-card-text
                    p Lorem
v-layout.style-login-v(justify-center)
    v-flex(xs12, style="max-width:1000px;display:flex;align-items:center;justify-content: center;")
        //-v-card(flat, dark, color="transparent")
            v-card-text
                v-layout(row,wrap)
                    v-flex(xs12).text-center
                        div(style="width:600px;height:220px;background-size:100%;background-image:url('https://sisep.minedu.gob.bo/img/logo-ugpsep-horizontal.png');opacity:0.1;")
                        //-div(style="width:500px;height:500px;background-size:100%;background-image:url('https://sisep.minedu.gob.bo/img/fondo-escudo.png');opacity:0.3;")
                        //-img.text-xs-center(src="https://sisep.minedu.gob.bo/img/logo-ugpsep-2026.jpg", :width="logoHome" style="background-blend-mode: multiply !important;opacity:1;")
                        //- div.yellow.darken-3(style="border-radius:2px;width:100%;height:2px;margin-top:4px;margin-bottom:12px")
                        //- h2.white--text Sistema SISEP {{ version }}
                        //- h3.yellow--text Nro. de visitantes: {{ NroVistas }}
</template>

<style>
.style-login-v {
    background: url("https://sisep.minedu.gob.bo/img/10.jpg") no-repeat center center /cover
}
</style>

<script>
module.exports = {
    data() {
        return {
            a: 'b',
            NroVistas: 0,
            newversion: 0,
            version: null
        };
    },
    computed:{
        showLogo(){
            if(this.$store.state.windowSize.w>550){
                return true;
            }
            else{
                return false;
            }
        },
        logoHome(){
            if(this.$store.state.windowSize.w>550){
                return "400px";
            }
            else{
                return "300px";
            }
        }
    },
    methods: {
        async loadCounter(){
            try {
                this.NroVistas = await axios.get('/api/v1/get-counter');
            } catch (error) {
                this.NroVistas = 0
            }
        }
    },
    async mounted(){
        this.version = " - versión " + document.title.substr(document.title.length - 5)
        /*try {
            let resp = await axios.get("http://sisep.minedu.gob.bo:8083/info/sisep-info");
            this.version = " - versión " + resp.data.version;
        } catch (error) {
            this.version = null;
        }*/
    },
    created: function() {
        //this.loadCounter();
    }
};
</script>
